<template>
    <div class="form__container" :id="'input_' + inputData.id">
        <fieldset>
            <legend class="form__heading">
                <span>{{ inputData.name }}</span>
                <required-indicator :inputData="inputData"></required-indicator>
            </legend>
            <p class="form__description" :id="'description_' + inputData.id" v-if="inputData.desc">{{ inputData.desc }}</p>
            <div class="form__input-container form__input-container--files">
                <div v-for="(fileName, index) in inputValues" class="form__input-container form__input-container--file">
                    <input class="form__input form__input--file visually-hidden"
                        :aria-describedby="(inputData.desc ? ('description_' + inputData.id) : '') + (inputData.error ? (' error_' + inputData.id) : '')"
                        type="file"
                        multiple
                        :id="'fileInput_' + inputData.id + '_' + index"
                        :name="inputData.id"
                        :fileIndex="index"
                        accept="image/png, image/jpeg, .pdf, .heif, .heic"
                        @change="updateInputValue"
                        >
                    <label class="form__label form__label--file"
                    :class="inputData.error ? 'form__input--error' : ''"
                    :for="'fileInput_' + inputData.id + '_' + index"
                    >{{ $t('formChooseFile')}}</label>
                    <span class="form__file-list">{{ fileName }}</span>
                </div>
            </div>
            <button v-if="numberOfFiles < 3"
                class="form__input-add-button"
                @click="addFileField"
                >Legg eventuelt til flere vedlegg
            </button>
            <div class="form__error" :id="'error_' + inputData.id" v-if="inputData.error" role="alert">{{ inputData.error }}</div>
        </fieldset>
        <div>
            <span class="form__explanation" v-if="inputData.explanation">{{ inputData.explanation }}</span>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, watch, computed } from 'vue';
import RequiredIndicator from './RequiredIndicator.vue';

export default {
    props: ['inputData'],
    emits: ['addFileToForm', 'inputValue'],
    components: {
        'required-indicator': RequiredIndicator
    },
    setup(props, ctx){
        const inputValue = ref('');
        const inputValues = ref([""]);

        function addFileField(){
            inputValues.value.push("");
        }

        function updateInputValue(event) {
            const fileIndex = event.target.getAttribute("fileIndex");
            const file = event.target.files[0];
            inputValues.value[fileIndex] = file.name;
            ctx.emit('addFileToForm', props.inputData.id, fileIndex, file);
        }

        watch(props, (oldValue, newValue) => {
            if (newValue.inputData.value) {
                inputValues.value = JSON.parse(newValue.inputData.value);
            }
        });

        onMounted(()=>{
            if(props.inputData.value && JSON.parse(props.inputData.value)){
                inputValues.value = JSON.parse(props.inputData.value);
            }
        })

        const numberOfFiles = computed(()=>{
            return inputValues.value.length;
        });

        return {
            inputValue,
            inputValues,
            numberOfFiles,
            addFileField,
            updateInputValue,
        }
    }
}
</script>